import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

const TooltipHover = ({ title }) => {

    return (
        <Tooltip
            title={title}
        >
            <IconButton sx={{ fontSize: "smaller" }}>
                <InfoIcon fontSize="inherit" />
            </IconButton>
        </Tooltip>
    );
}

export default TooltipHover;